import React, { useState } from "react";
import { authApi } from "../services/api";

export default function RedefinirSenha() {
  const params   = new URLSearchParams(window.location.search);
  const token    = params.get("token") || "";
  const [nova, setNova]       = useState("");
  const [confirma, setConfirma] = useState("");
  const [loading, setLoading]   = useState(false);
  const [msg, setMsg]           = useState(null);

  async function salvar(e) {
    e.preventDefault();
    if (nova.length < 6) return setMsg({ tipo:"erro", texto:"A senha deve ter pelo menos 6 caracteres." });
    if (nova !== confirma) return setMsg({ tipo:"erro", texto:"As senhas nao coincidem." });
    setLoading(true);
    try {
      await authApi.post("/auth/reset-by-token", { token, new_password: nova });
      setMsg({ tipo:"ok", texto:"Senha redefinida com sucesso! Voce ja pode fazer login." });
    } catch (err) {
      setMsg({ tipo:"erro", texto: err?.response?.data?.detail || "Token invalido ou expirado." });
    } finally {
      setLoading(false);
    }
  }

  if (!token) return (
    <div style={{ minHeight:"100vh", background:"#0f172a", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ color:"#ef4444", fontSize:16 }}>Link invalido. Solicite uma nova redefinicao de senha.</div>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:"#0f172a", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"#131929", border:"1px solid #1e293b", borderRadius:16, padding:"40px 36px", width:"100%", maxWidth:420 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ fontSize:26, fontWeight:800, color:"#fff" }}>SAAS<span style={{ color:"#6366f1" }}>.GL</span></div>
          <div style={{ fontSize:13, color:"#64748b", marginTop:4 }}>Nova Senha</div>
        </div>

        {msg?.tipo === "ok" ? (
          <div style={{ background:"#22c55e22", border:"1px solid #22c55e55", borderRadius:10, padding:"20px", textAlign:"center" }}>
            <div style={{ fontSize:28, marginBottom:8 }}>✅</div>
            <div style={{ color:"#22c55e", fontSize:14, fontWeight:600, marginBottom:6 }}>Senha alterada!</div>
            <div style={{ color:"#94a3b8", fontSize:13 }}>{msg.texto}</div>
            <a href="/login" style={{ display:"inline-block", marginTop:20, background:"linear-gradient(135deg,#6366f1,#3b82f6)", color:"#fff", fontSize:14, fontWeight:700, textDecoration:"none", padding:"12px 32px", borderRadius:8 }}>Ir para o login</a>
          </div>
        ) : (
          <>
            <p style={{ color:"#94a3b8", fontSize:14, lineHeight:1.6, marginBottom:24 }}>Escolha uma nova senha segura para sua conta.</p>
            <form onSubmit={salvar}>
              <div style={{ marginBottom:14 }}>
                <label style={{ fontSize:12, color:"#64748b", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.06em" }}>Nova Senha</label>
                <input type="password" value={nova} onChange={e => setNova(e.target.value)} placeholder="Minimo 6 caracteres" required
                  style={{ width:"100%", padding:"12px 14px", background:"#0f172a", border:"1px solid #334155", borderRadius:8, color:"#f1f5f9", fontSize:14, boxSizing:"border-box" }} />
              </div>
              <div style={{ marginBottom:20 }}>
                <label style={{ fontSize:12, color:"#64748b", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:"0.06em" }}>Confirmar Senha</label>
                <input type="password" value={confirma} onChange={e => setConfirma(e.target.value)} placeholder="Repita a senha" required
                  style={{ width:"100%", padding:"12px 14px", background:"#0f172a", border:"1px solid #334155", borderRadius:8, color:"#f1f5f9", fontSize:14, boxSizing:"border-box" }} />
              </div>
              {msg?.tipo === "erro" && (
                <div style={{ background:"#ef444422", border:"1px solid #ef444455", borderRadius:8, padding:"10px 14px", color:"#ef4444", fontSize:13, marginBottom:16 }}>{msg.texto}</div>
              )}
              <button type="submit" disabled={loading}
                style={{ width:"100%", padding:"13px", background:"linear-gradient(135deg,#6366f1,#3b82f6)", border:"none", borderRadius:10, color:"#fff", fontSize:15, fontWeight:700, cursor:loading?"not-allowed":"pointer", opacity:loading?0.7:1 }}>
                {loading ? "Salvando..." : "Redefinir Senha"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}